<div class="warning blue-offer-gpa">
  <span class="title">{{ title }} </span> <br />
  <span>{{ mainText }}</span> <br />
  <span class="link" (click)="showGpaOfferDetailsModal()">{{ link }}</span> <br />
  <span>{{ extraText }}</span> <br />
</div>
